import { chartColor } from '@/lib/chart-colors';

export const AUDIENCE_COMPOSITION_AUDIENCE_COLOR = chartColor(1);
export const AUDIENCE_COMPOSITION_OTHER_USERS_COLOR = 'hsl(var(--muted))';

export type AudienceCompositionSegment = {
  key: 'audience' | 'other';
  value: number;
  actualValue: number;
  label: string;
  color: string;
};

type AudienceCompositionLabels = {
  usersInAudience: string;
  otherUsers: string;
};

type BuildAudienceCompositionSegmentsInput = {
  targetUsersCount: number | undefined;
  totalUserbaseCount: number;
  labels: AudienceCompositionLabels;
  zeroTotalSliceColor?: 'audience' | 'other';
};

export function buildAudienceCompositionSegments({
  targetUsersCount,
  totalUserbaseCount,
  labels,
  zeroTotalSliceColor = 'audience',
}: BuildAudienceCompositionSegmentsInput): AudienceCompositionSegment[] {
  if (targetUsersCount === undefined) {
    return [
      {
        key: 'other',
        value: 1,
        actualValue: 0,
        label: labels.otherUsers,
        color: AUDIENCE_COMPOSITION_OTHER_USERS_COLOR,
      },
    ];
  }

  if (totalUserbaseCount <= 0) {
    const hasAudience = targetUsersCount > 0;
    const useAudienceColor = hasAudience && zeroTotalSliceColor !== 'other';

    return [
      {
        key: useAudienceColor ? 'audience' : 'other',
        value: 1,
        actualValue: 0,
        label: useAudienceColor ? labels.usersInAudience : labels.otherUsers,
        color: useAudienceColor
          ? AUDIENCE_COMPOSITION_AUDIENCE_COLOR
          : AUDIENCE_COMPOSITION_OTHER_USERS_COLOR,
      },
    ];
  }

  const otherUsersCount = Math.max(0, totalUserbaseCount - targetUsersCount);
  const segments: AudienceCompositionSegment[] = [];

  if (targetUsersCount > 0) {
    segments.push({
      key: 'audience',
      value: targetUsersCount,
      actualValue: targetUsersCount,
      label: labels.usersInAudience,
      color: AUDIENCE_COMPOSITION_AUDIENCE_COLOR,
    });
  }

  if (otherUsersCount > 0) {
    segments.push({
      key: 'other',
      value: otherUsersCount,
      actualValue: otherUsersCount,
      label: labels.otherUsers,
      color: AUDIENCE_COMPOSITION_OTHER_USERS_COLOR,
    });
  }

  return segments;
}
